import {SHOW_LOADING, HIDE_LOADING} from './action';

function fullLoading(state = false, action) {
    switch (action.type) {
        case SHOW_LOADING:
            return {
                isShow: true,
                msg: action.msg
            };
        case HIDE_LOADING:
            return {
                isShow: false
            };
        default:
            return state;

    }
}

export default fullLoading;


// WEBPACK FOOTER //
// ./components/redux/loading/reducer.js